define([
	'internal_util/Configuration'
], function (
	Configuration
) {
	'use strict';

	return function () {
		var _canvas = document.createElement('canvas'),
			_context = _canvas.getContext('2d'),
			_animation = false,
			_animationStart,
			_animationTimer;

		_context.canvas.width = 284;
		_context.canvas.height = 93;

		_context.save();

		_context.scale(3, 3);
		_context.font = 'bold 14px Arial, Helvetica, sans-serif';
		_context.lineWidth = 0.35;

		_context.fillStyle = '#4d4948';
		_context.fillText('Sk', 14.44, 28.09);

		_context.fillStyle = '#93c36c';
		_context.fillText('ID', 32.28, 27.85);

		_context.strokeStyle = '#58ab27';
		_context.strokeText('ID', 32.28, 27.85);

		_context.fillStyle = '#4d4948';
		_context.fillText('entity', 46.77, 28.09);

		_context.restore();

		// private methods

		function draw(interval, index, first) {
			_animationTimer = window.requestAnimationFrame(function () {
				if (!_animation) {
					return;
				}

				if (first || (Date.now() - _animationStart) >= interval) {
					_context.save();

					_context.clearRect(0, 0, _context.canvas.width, _context.canvas.height);

					_context.scale(3, 3);
					_context.font = 'bold 14px Arial, Helvetica, sans-serif';
					_context.lineWidth = 0.35;

					_context.fillStyle = '#4d4948';
					_context.fillText('Sk', 14.44, 28.09);

					_context.fillStyle = '#93c36c';
					_context.fillText('ID', 32.28, 27.85);

					_context.strokeStyle = '#58ab27';
					_context.strokeText('ID', 32.28, 27.85);

					_context.fillStyle = '#4d4948';
					_context.fillText('entity', 46.77, 28.09);

					_context.strokeStyle = "#0099ff";

					_context.lineWidth = 1.5;
					_context.beginPath();

					_context.moveTo(11.464858, 27.4786);

					if (index >= 1) _context.bezierCurveTo(-0.852542, 29.3296, -3.474842, 16.0867, 8.483658, 16.20946);
					if (index >= 2) _context.bezierCurveTo(-4.787842, 7.97006, 17.103358, 1.02056, 22.092058, 6.00596);
					if (index >= 3) _context.bezierCurveTo(22.159658, 0.53496, 35.024058, -1.52064, 42.929058, 4.03166);
					if (index >= 4) _context.bezierCurveTo(49.532558, -2.82844, 64.762658, 2.61576, 64.672558, 9.91016);
					if (index >= 5) _context.bezierCurveTo(71.088958, 0.73596, 86.801658, 1.30376, 85.708458, 12.77696);
					if (index === 6) _context.bezierCurveTo(96.667958, 15.37696, 96.106958, 27.58136, 87.563758, 28.58616);

					_context.stroke();
					_context.closePath();

					_context.restore();

					if (index >= 6) {
						index = -1;
					}

					index++;

					_animationStart = Date.now();
				}

				draw(interval, index, false);
			}, _canvas);
		}


		// public methods

		this.get = function () {
			return _canvas;
		};

		this.enableAnimation = function () {
			_animation = true;
			_animationStart = Date.now();

			draw(Configuration.get('LOGO_CANVAS_INTERVAL'), 0, true);
		};

		this.disableAnimation = function () {
			if (window.cancelAnimationFrame) {
				window.cancelAnimationFrame(_animationTimer);
			}

			_animation = false;

			_context.save();

			_context.clearRect(0, 0, _context.canvas.width, _context.canvas.height);

			_context.scale(3, 3);
			_context.lineWidth = 0.35;

			_context.fillStyle = '#d0d0d0';
			_context.strokeStyle = '#d0d0d0';

			_context.font = 'bold 14px Arial, Helvetica, sans-serif';
			_context.fillText('Sk', 14.44, 28.09);
			_context.fillText('ID', 32.28, 27.85);
			_context.strokeText('ID', 32.28, 27.85);
			_context.fillText('entity', 46.77, 28.09);

			_context.lineWidth = 1.5;
			_context.beginPath();

			_context.moveTo(11.464858, 27.4786);

			_context.bezierCurveTo(-0.852542, 29.3296, -3.474842, 16.0867, 8.483658, 16.20946);
			_context.bezierCurveTo(-4.787842, 7.97006, 17.103358, 1.02056, 22.092058, 6.00596);
			_context.bezierCurveTo(22.159658, 0.53496, 35.024058, -1.52064, 42.929058, 4.03166);
			_context.bezierCurveTo(49.532558, -2.82844, 64.762658, 2.61576, 64.672558, 9.91016);
			_context.bezierCurveTo(71.088958, 0.73596, 86.801658, 1.30376, 85.708458, 12.77696);
			_context.bezierCurveTo(96.667958, 15.37696, 96.106958, 27.58136, 87.563758, 28.58616);

			_context.stroke();
			_context.closePath();

			_context.restore();
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/canvas/LogoCanvas.js
// module id = 148
// module chunks = 1